<!-- <div class="footer-wrap">
  <div class="footer-top">
    <div class="container">
      <div class="row no-gutters">
  -->
<!-- ===== LEFT COLUMN (36%) ===== -->
<!-- <div class="col-lg-4">
          <div class="footer-content-wrapper">
            <img src="../../../assets/common/black-logo.png" alt="Kalpita Technologies" class="footer-logo">
            <p class="company-description">
              Kalpita is an outcome-focused IT company aimed at delivering unique, reliable, and innovative software
              solutions.
            </p>
<h6 class="footer-heading">OFFICE LOCATIONS</h6>
<div class="row">
<div class="col-sm-6 office-location">
<div class="d-flex align-items-center">
<img src="../../../assets/footer/Ind-flag.svg" alt="India" class="flag-icon">
<strong>India</strong>
</div>
<p>
<a target="_blank"
         href="https://www.google.com/maps/place/Kalpita+Technologies+Pvt+LTD+%7C+Software+development+company/@13.0249507,77.6343714,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae173d17cdca3b:0x35dac77c630483a9!8m2!3d13.0249507!4d77.6369463!16s%2Fg%2F11hyrdr379?entry=ttu"
         class="text-decoration-none text-dark">
        4M 417/A, 4th Floor,<br>
        HRBR Layout 3rd Block,<br>
        Kammanahalli main road,<br>
        Bengaluru, Karnataka 560043, India
</a>
</p>
</div>
 
  <div class="col-sm-6 office-location">
<div class="d-flex align-items-center">
<img src="../../../assets/footer/Us-flag.svg" alt="USA" class="flag-icon">
<strong>USA</strong>
</div>
<p>
<a target="_blank"
         href="https://www.google.com/maps/place/1250+S+Capital+of+Texas+Hwy+6th+2,+Austin,+TX+78746,+USA/@30.2799473,-97.8288471,18z/data=!4m9!1m2!2m1!1sKalpita+Technologies+Inc,+6th+Floor,+Building+2,+1250+South+Capital+of+Texas+Highway,+Austin,+Texas+78746!3m5!1s0x865b4a88d3b083e5:0x9bd4650f73f22723!8m2!3d30.2803951!4d-97.8233052!15sCmlLYWxwaXRhIFRlY2hub2xvZ2llcyBJbmMsIDZ0aCBGbG9vciwgQnVpbGRpbmcgMiwgMTI1MCBTb3V0aCBDYXBpdGFsIG9mIFRleGFzIEhpZ2h3YXksIEF1c3RpbiwgVGV4YXMgNzg3NDaSARBjb21wb3VuZF9zZWN0aW9u"
         class="text-decoration-none text-dark">
        Suite #300, 3rd Floor, Building 2,<br>
        1250 South Capital of Texas Highway,<br>
        Austin, Texas 78746, USA
</a>
</p>
</div>
</div>
          </div>
 
        </div> -->
<!-- ===== RIGHT COLUMN (64%) ===== -->
<!-- <div class="col-lg-8">
          <div class="footer-content-wrapper right-column">
            <div class="row">
              <div class="col-md-3">
                <h6 class="section-heading">USEFUL LINKS</h6>
                <ul class="link-list">
                  <li><a (click)="nav('company/about-us')">About Us</a></li>
                  <li><a (click)="nav('case-studies')">Case Studies</a></li>
                  <li><a (click)="nav('careers/kalpita-careers')">Careers</a></li>
                  <li><a (click)="nav('blogs/blog')">Blog</a></li>
                  <li><a (click)="nav('contact-us')">Contact</a></li>
                  <li><a (click)="nav('newsletters/newsletter')">Newsletter</a></li>
                  <li><a (click)="nav('company/annual-report')">Annual Report</a></li>
                  <li><a href="../../../assets/brochure/Kalpita_Brochure.pdf" target="_blank">KT Brochure</a></li>
                </ul>
              </div> -->
<!-- <div class="col-md-6">
                <h6 class="section-heading">CONTACT PHONE</h6>
                <ul class="link-list">
                  <li><img src="../../../assets/footer/Indiaphone-line (4).svg" alt="India Phone">India Office - <a
                      href="tel:+918762033990">(+91) 87620-33990</a></li>
                  <li><img src="../../../assets/footer/Usaphone-line (4) (1).svg" alt="USA Phone">USA Office - <a
                      href="tel:+15126403251">(+1) 512-640-3251</a></li>
                  <li><img src="../../../assets/footer/Sales-service-line.svg" alt="Sales">Sales - <a
                      href="tel:+918904087107">(+91) 89040-87107</a></li>
                  <li><img src="../../../assets/footer/Recruit-service-2-line.svg" alt="Recruitment">Recruitment - <a
                      href="tel:+918762011217">(+91) 87620-11217</a></li>
                </ul>
                <div class="social">
                  <h6 class="footer-heading">SOCIAL MEDIA</h6>
                  <div class="social-icons">
                    <a href="https://www.youtube.com/channel/UCpptWhCmPPMwNFccr_mdmrA/featured" target="_blank" aria-label="YouTube"><img
                        src="../../../assets/footer/Youtube-icon.svg" alt="YouTube" /></a>
                    <a href="https://in.linkedin.com/company/kalpitatechnologies" target="_blank" aria-label="LinkedIn"><img
                        src="../../../assets/footer/linked-in-icon.svg" alt="LinkedIn" /></a>
                    <a href="https://www.instagram.com/kalpitatechnologies/" target="_blank" aria-label="Instagram"><img
                        src="../../../assets/footer/insta-icon.svg" alt="Instagram" /></a>
                    <a href="https://www.facebook.com/kalpitatechnologies" target="_blank" aria-label="Facebook"><img
                        src="../../../assets/footer/fb-icon.svg" alt="Facebook" /></a>
                    <a href="https://twitter.com/KalpitaTech" target="_blank" aria-label="Twitter"><img
                        src="../../../assets/footer/twitter.svg" alt="Twitter" /></a> -->
<!-- <a href="https://www.threads.com/@kalpitatechnologies" target="_blank" aria-label="Threads"><img
                        src="../../../assets/footer/threads.svg" alt="Threads" /></a> -->
<!-- </div>
                </div>
              </div>
              <div class="col-md-3">
                <h6 class="section-heading">CONTACT EMAIL</h6>
                <ul class="link-list">
                  <li><img src="../../../assets/footer/mail-send-line.svg" alt="General Email"><a
                      href="mailto:connect@kalpitatechnologies.com">connect&#64;kalpitatechnologies.com</a></li>
                  <li><img src="../../../assets/footer/Operationuser-2-line.svg" alt="Operations Email"><a
                      href="mailto:operations@kalpitatechnologies.com">operations&#64;kalpitatechnologies.com</a></li>
                  <li><img src="../../../assets/footer/salesuser-add-line.svg" alt="Sales Email"><a
                      href="mailto:sales@kalpitatechnologies.com">sales&#64;kalpitatechnologies.com</a></li>
                  <li><img src="../../../assets/footer/Recr-ind.svg" alt="India Recruitment"><a
                      href="mailto:recruitment@kalpitatechnologies.com">recruitment&#64;kalpitatechnologies.com</a>
                  </li>
                  <li><img src="../../../assets/footer/Recr-us.svg" alt="US Recruitment"><a
                      href="mailto:Recruit_US@kalpitatechnologies.com">Recruit_US&#64;kalpitatechnologies.com</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
 
        <div class="certification-section">
          <h6 class="footer-heading">CERTIFICATION</h6>
          <div class="certification-row">
            <img src="../../../assets/footer/GoogleFooterRating.webp" class="cert-img" alt="Google Rating">
            <img src="../../../assets/footer/GlassDoor-Footer.webp" class="cert-img" alt="Glassdoor Rating">
            <img src="../../../assets/footer/AmbitionBox.webp" class="cert-img" alt="AmbitionBox Rating">
            <img src="../../../assets/footer/GratePlace-Footer.webp" class="cert-img" alt="Great Place to Work">
            <img src="../../../assets/footer/TDTC-Footer.webp" class="cert-img" alt="TDTC Certification">
            <img src="../../../assets/footer/TSDC-Footer.webp" class="cert-img" alt="TSDC Certification">
            <img src="../../../assets/footer/TopWeb-Footer.svg" class="cert-img" alt="TSDC Certification">
            <img src="../../../assets/footer/AICPA.webp" class="cert-img" alt="SOC2 Compliance">
            <img src="../../../assets/footer/ISOCer-Footer.webp" class="cert-img" alt="ISO Certification">
          </div>
        </div>
      </div>
    </div>
  </div>
 
  <div class="footer-bottom">
    <div class="container">
      <p>Copyright © {{ currentyear }}. All Rights Reserved.</p>
    </div>
  </div> -->
<!-- <button *ngIf="isShow" (click)="gotoTop()" class="goto-top-btn" title="Go to top"><i
      class="ri-chat-3-fill"></i></button> -->
<!-- </div> -->

<!-- ------------------------------------------------------------------------------------------------------ -->
<div class="outer">
  <footer class="footer-container">
    <div class="footer-header">
      <div class="footer-header-content">
        <div class="header-logo-section">
          <img src="../../../assets/common/black-logo.png" alt="Kalpita Technologies" class="footer-logo">
        </div>
        <div class="header-title-section">
          <h2>CONTACT PHONE</h2>
        </div>
        <div class="header-title-section">
          <h2>USEFUL LINKS</h2>
        </div>
      </div>
    </div>

    <div class="footer-content">
      <!-- Left Section: Company Info -->
      <div class="footer-section company-info">
        <p class="company-description">
          Kalpita is an outcome-focused IT company aimed at delivering unique, reliable, and innovative software
          solutions.
        </p>

        <div class="office-address">
          <h3 class="office-title">INDIA</h3>
          <!-- <address>
          4M 417/A, 4th Floor,<br>
          HRBR Layout 3rd Block,<br>
          Kammanahalli main road,<br>
          Bengaluru, Karnataka 560043,<br>
          India
        </address> -->
          <address>
            <a target="_blank"
              href="https://www.google.com/maps/place/Kalpita+Technologies+Pvt+LTD+%7C+Software+development+company/@13.0249507,77.6343714,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae173d17cdca3b:0x35dac77c630483a9!8m2!3d13.0249507!4d77.6369463!16s%2Fg%2F11hyrdr379?entry=ttu"
              class="text-decoration-none text-light">
              4M 417/A, 4th Floor,<br>
              HRBR Layout 3rd Block,<br>
              Kammanahalli main road,<br>
              Bengaluru, Karnataka 560043, India
            </a>
          </address>

        </div>

        <div class="office-address">
          <h3 class="office-title">USA</h3>
          <!-- <address>
          Suite #300, 3rd Floor,<br>
          Building 2, 1250 South Capital<br>
          of Texas Highway, Austin,<br>
          Texas 78746, USA
        </address> -->
          <address>
            <a target="_blank"
              href="https://www.google.com/maps/place/1250+S+Capital+of+Texas+Hwy+6th+2,+Austin,+TX+78746,+USA/@30.2799473,-97.8288471,18z/data=!4m9!1m2!2m1!1sKalpita+Technologies+Inc,+6th+Floor,+Building+2,+1250+South+Capital+of+Texas+Highway,+Austin,+Texas+78746!3m5!1s0x865b4a88d3b083e5:0x9bd4650f73f22723!8m2!3d30.2803951!4d-97.8233052!15sCmlLYWxwaXRhIFRlY2hub2xvZ2llcyBJbmMsIDZ0aCBGbG9vciwgQnVpbGRpbmcgMiwgMTI1MCBTb3V0aCBDYXBpdGFsIG9mIFRleGFzIEhpZ2h3YXksIEF1c3RpbiwgVGV4YXMgNzg3NDaSARBjb21wb3VuZF9zZWN0aW9u"
              class="text-decoration-none text-light">
              Suite #300, 3rd Floor, Building 2,<br>
              1250 South Capital of Texas Highway,<br>
              Austin, Texas 78746, USA
            </a>
          </address>
        </div>
      </div>

      <!-- Middle Section: Contact Info -->
      <div class="footer-section contact-section">
        <div class="contact-list">
          <div *ngFor="let contact of contactPhones" class="contact-item">
            <span class="contact-icon">{{ contact.icon }}</span>
            <div class="contact-details">
              <span class="contact-label">{{ contact.label }}</span>
              <span class="contact-separator">-</span>
              <a [href]="'tel:' + contact.telNumber" class="contact-value">
                {{ contact.number }}
              </a>
            </div>
          </div>
        </div>

        <div class="section-header email-header">
          <h2>CONTACT EMAIL</h2>
        </div>

        <div class="email-list">
          <div *ngFor="let email of contactEmails" class="email-item">
            <span class="email-icon">📧</span>
            <a [href]="'mailto:' + email.email" class="email-value">
              {{ email.email }}
            </a>
          </div>
        </div>
      </div>

      <!-- Right Section: Useful Links -->
      <div class="footer-section links-section">
        <ul class="useful-links">
          <li *ngFor="let link of usefulLinks">
            <a *ngIf="link.route !== 'BROCHURE' && link.route !== 'CONTACT_MODAL'" (click)="onLinkClick(link.route)"
              class="link-item">
              {{ link.label }}
            </a>

            <a *ngIf="link.route === 'CONTACT_MODAL'" (click)="openContactModal()" class="link-item">
              {{ link.label }}
            </a>

            <a *ngIf="link.route === 'BROCHURE'" href="../../../assets/brochure/Kalpita_Brochure.pdf" target="_blank"
              class="link-item">
              {{ link.label }}
            </a>
          </li>
        </ul>

        <div class="social-icons">
          <a href="https://www.youtube.com/channel/UCpptWhCmPPMwNFccr_mdmrA/featured" target="_blank"
            aria-label="YouTube"><img src="../../../assets/footer/Youtube-icon.svg" alt="YouTube" /></a>
          <a href="https://in.linkedin.com/company/kalpitatechnologies" target="_blank" aria-label="LinkedIn"><img
              src="../../../assets/footer/linked-in-icon.svg" alt="LinkedIn" /></a>
          <a href="https://www.instagram.com/kalpitatechnologies/" target="_blank" aria-label="Instagram"><img
              src="../../../assets/footer/insta-icon.svg" alt="Instagram" /></a>
          <a href="https://www.facebook.com/kalpitatechnologies" target="_blank" aria-label="Facebook"><img
              src="../../../assets/footer/fb-icon.svg" alt="Facebook" /></a>
          <a href="https://twitter.com/KalpitaTech" target="_blank" aria-label="Twitter"><img
              src="../../../assets/footer/twitter.svg" alt="Twitter" /></a>
          <a href="https://www.threads.com/@lifeatkalpita" target="_blank" aria-label="Threads"><img
              src="../../../assets/footer/threads.png" alt="Threads" /></a>
        </div>

        <!-- <div class="social-media">
        <a *ngFor="let social of socialLinks" 
           [href]="social.url" 
           (click)="onSocialClick($event, social.name)"
           class="social-icon"
           [attr.aria-label]="social.name">
          <span class="icon-circle">
            <ng-container [ngSwitch]="social.icon">
              <ng-container *ngSwitchCase="'youtube'">▶</ng-container>
              <ng-container *ngSwitchCase="'linkedin'">in</ng-container>
              <ng-container *ngSwitchCase="'instagram'">📷</ng-container>
              <ng-container *ngSwitchCase="'facebook'">f</ng-container>
              <ng-container *ngSwitchCase="'twitter'">𝕏</ng-container>
              <ng-container *ngSwitchCase="'threads'"><i class="fi fi-brands-threads"></i></ng-container>
            </ng-container>
          </span>
        </a>
      </div> -->
      </div>
    </div>
    <div class="certifications-wrapper">
      <div class="certification-section">
        <!-- <h6 class="footer-heading">Certifications</h6> -->
        <div class="certification-row">
          <!-- Google Rating -->
          <a href="https://g.page/r/CamDBGN8x9o1EAE/review" target="_blank" rel="noopener noreferrer">
            <img src="../../../assets/footer/GoogleFooterRating.webp" class="cert-img" alt="Google Rating">
          </a>

          <!-- Glassdoor -->
          <a href="https://www.glassdoor.co.in/Reviews/Kalpita-Technologies-Reviews-E3039050.htm" target="_blank"
            rel="noopener noreferrer">
            <img src="../../../assets/footer/GlassDoor-Footer.webp" class="cert-img" alt="Glassdoor Rating">
          </a>

          <!-- AmbitionBox -->
          <a href="https://www.ambitionbox.com/reviews/kalpita-technologies-reviews" target="_blank"
            rel="noopener noreferrer">
            <img src="../../../assets/footer/AmbitionBox.webp" class="cert-img" alt="AmbitionBox Rating">
          </a>

          <!-- TDTC -->
          <a href="https://selectedfirms.co/companies/digital-transformation?utm_source=kalpitatechnologies_private_limited&utm_medium=badge&utm_campaign=digital_transformation&utm_term=top_digital_transformation_company&utm_content=agency_badge&utm_marketing_tactic=badge_organic"
            target="_blank" rel="noopener noreferrer">
            <img src="../../../assets/footer/TDTC-Footer.webp" class="cert-img" alt="TDTC Certification">
          </a>

          <!-- TSDC -->
          <a href="https://selectedfirms.co/companies/software-development?utm_source=kalpita_technologies_private_limited&utm_medium=badge&utm_campaign=software_development&utm_term=top_software_development_company&utm_content=agency_badge&utm_marketing_tactic=badge_organic"
            target="_blank" rel="noopener noreferrer">
            <img src="../../../assets/footer/TSDC-Footer.webp" class="cert-img" alt="TSDC Certification">
          </a>

          <!-- Top Web Development -->
          <a href="https://www.goodfirms.co/companies/web-development-agency/bangalore" target="_blank"
            rel="noopener noreferrer">
            <img src="../../../assets/footer/top-web-dev.png" class="cert-img" alt="TSDC Certification">
          </a>
          <img src="../../../assets/footer/goodFirms-research-partner-badge.png" class="cert-img"
            alt="GoodFirms-Research partner">
          <!-- <img src="../../../assets/footer/AICPA.webp" class="cert-img" alt="SOC2 Compliance">
          <img src="../../../assets/footer/GratePlace-Footer.webp" class="cert-img" alt="Great Place to Work">
          <img src="../../../assets/footer/ISOCer-Footer.webp" class="cert-img" alt="ISO Certification"> -->
        </div>
      </div>
    </div>

    <!-- <div class="copyright">
      <p>Copyright © {{ currentyear }}. All Rights Reserved.</p>
    </div> -->
  </footer>
  <!-- <div class="certifications-wrapper">
  <div class="certification-section">
    <h6 class="footer-heading">Certifications</h6>
    <div class="certification-row">
      <img src="../../../assets/footer/GoogleFooterRating.webp" class="cert-img" alt="Google Rating">
      <img src="../../../assets/footer/GlassDoor-Footer.webp" class="cert-img" alt="Glassdoor Rating">
      <img src="../../../assets/footer/AmbitionBox.webp" class="cert-img" alt="AmbitionBox Rating">
      <img src="../../../assets/footer/GratePlace-Footer.webp" class="cert-img" alt="Great Place to Work">
      <img src="../../../assets/footer/TDTC-Footer.webp" class="cert-img" alt="TDTC Certification">
      <img src="../../../assets/footer/TSDC-Footer.webp" class="cert-img" alt="TSDC Certification">
      <img src="../../../assets/footer/TopWeb-Footer.svg" class="cert-img" alt="Top Web Certification">
      <img src="../../../assets/footer/AICPA.webp" class="cert-img" alt="SOC2 Compliance">
      <img src="../../../assets/footer/ISOCer-Footer.webp" class="cert-img" alt="ISO Certification">
    </div>
  </div>
</div> -->

  <div class="copyright">
    <p>Kalpita Technologies<span class="fs-4 mt-3">®</span> is a Registered Trademark © {{ currentyear }} All Rights
      Reserved.</p>
    <!-- <p class="copyright">Kalpita Technologies<span class="fs-4 mt-3">®</span> is a Registered Trademark © {{currentyear}} All Rights
          Reserved. </p> -->
    <div class="row">
      <div class="col-md-12 d-flex justify-content-center">
        <p><span class="mx-2 policy-link"><a (click)="nav('aboutcompany/legal/kalpita-privacy-policy')">
              Privacy Policy
            </a></span>
          <span class="mx-2 policy-link"><a (click)="nav('aboutcompany/legal/kalpita-cookie-policy')">
              Cookie Policy
            </a></span>
          <span class="mx-2 policy-link">
            <a (click)="nav('aboutcompany/legal/kalpita-terms-of-use')">Terms of Use</a>
          </span>
        </p>
      </div>
    </div>
  </div>
  <!-- <div class="row py-2">
        <div class="row">
          <div class="col-md-12 d-flex justify-content-center">
          <p><span class="mx-2 policy-link"><a href="aboutcompany/legal/kalpita-privacy-policy" (click)="nav('company/legal/kalpita-privacy-policy')">Privacy Policy</a></span> 
            <span class="mx-2 policy-link"><a href="aboutcompany/legal/kalpita-cookie-policy" (click)="nav('company/legal/kalpita-cookie-policy')">Cookie Policy</a></span></p>
          </div>
        </div>
    </div> -->
</div>